import React from "react";
import { baseColor } from "../..";

export type InputFileProps = {
  id: string;
  block?: boolean;
  children: React.ReactNode;
  className?: string;
  color?: "blue" | "green" | "red" | "yellow" | "indigo" | "dark" | "violet";
  disabled?: boolean;
  outline?: boolean;
  rounded?: boolean;
  multiple?: boolean;
  size?: "sm" | "md" | "lg";
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const style = {
  rounded: `rounded-full`,
  block: `flex justify-center w-full`,
  default: `flex px-4 m justify-center font-medium rounded-md focus:outline-none shadow transition ease-in duration-200`,
  disabled: `opacity-60 sm:cursor-not-allowed`,
  sizes: {
    sm: "px-6 py-1 text-sm",
    md: "px-6 py-2",
    lg: "px-6 py-3 text-lg",
  },
  color: {
    blue: {
      bg: `text-white bg-blue-600 focus:ring-2 focus:ring-offset-2 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 `,
      outline: `border-blue-600 border-2 text-blue-700 active:bg-blue-600 active:text-white`,
    },
    green: {
      bg: `text-white bg-green-600 focus:ring-2 focus:ring-offset-2 hover:bg-green-700 focus:ring-green-500 focus:ring-offset-green-200`,
      outline: `border-green-600 border-2 text-green-700 active:bg-green-600 active:text-white`,
    },
    red: {
      bg: `text-white bg-red-600 focus:ring-2 focus:ring-offset-2 hover:bg-red-700 focus:ring-red-500 focus:ring-offset-red-200`,
      outline: `border-red-600 border-2 text-red-600 active:bg-red-600 active:text-white`,
    },
    yellow: {
      bg: `text-white bg-yellow-500 focus:ring-2 focus:ring-offset-2 hover:bg-yellow-600 focus:ring-yellow-500 focus:ring-offset-yellow-200`,
      outline: `border-yellow-500 border-2 text-yellow-500 active:bg-yellow-500 active:text-white`,
    },
    indigo: {
      bg: `text-white bg-indigo-600 focus:ring-2 focus:ring-offset-2 hover:bg-indigo-700 focus:ring-indigo-600 focus:ring-offset-indigo-200`,
      outline: `border-indigo-600 border-2 text-indigo-600 active:bg-indigo-500 active:text-white`,
    },
    violet: {
      bg: `text-white bg-violet-600 focus:ring-2 focus:ring-offset-2 hover:bg-violet-700 focus:ring-violet-600 focus:ring-offset-violet-200`,
      outline: `border-violet-600 border-2 text-violet-600 active:bg-violet-500 active:text-white`,
    },
    dark: {
      bg: `text-white bg-black focus:ring-2 focus:ring-offset-2 hover:bg-black-600 focus:ring-gray-500 focus:ring-offset-gray-200`,
      outline: `border-black border-2 text-gray-900 active:bg-black active:text-white`,
    }
  },
};

const colors = (outline: boolean | undefined) => ({
  blue: outline ? style.color.blue.outline : style.color.blue.bg,
  green: outline ? style.color.green.outline : style.color.green.bg,
  red: outline ? style.color.red.outline : style.color.red.bg,
  dark: outline ? style.color.dark.outline : style.color.dark.bg,
  yellow: outline ? style.color.yellow.outline : style.color.yellow.bg,
  indigo: outline ? style.color.indigo.outline : style.color.indigo.bg,
  violet: outline ? style.color.violet.outline : style.color.violet.bg,
});

const InputFile = ({
  id,
  block = false,
  children,
  className,
  color = baseColor,
  disabled = false,
  outline,
  rounded,
  size = "md",
  multiple = false,
  onChange,
}: InputFileProps) => {
  return (
    <label
      htmlFor={`name-${id}`}
      className={`
        cursor-pointer
        w-fit
        ${block ? style.block : ""}
        ${rounded ? style.rounded : "rounded"}
        ${color ? colors(outline)[color] : colors(outline).dark}
        ${className}
        ${style.sizes[size]}
        ${style.default}
        ${disabled ? style.disabled : ''}
      `}
    >
      {children}
      <input
        type={"file"}
        name={`name-${id}`}
        id={`name-${id}`}
        className="hidden"
        onChange={onChange}
        multiple={multiple}
        disabled={disabled}
      />
    </label>
  );
};
export default InputFile;
